import { DropdownItem } from 'types/api/SystemTenant/AROKMS/TableDefinitionTypes';

export function resolveCubeLayerSelection(
  cubeId: string | undefined,
  selectedCubeId: string | undefined,
  selectedLayer: DropdownItem | null,
  layers: DropdownItem[] | undefined,
): DropdownItem | null {
  if (!cubeId || cubeId !== selectedCubeId || !selectedLayer) return null;
  return layers?.find(layer => String(layer.value) === String(selectedLayer.value)) ? selectedLayer : null;
}
